import React from 'react';
import toast from 'react-hot-toast';
import { FileText } from 'lucide-react';

// "Plan PDF" quick-action tile — opens the tariff/plan PDF an admin uploaded for
// this package/plan (Packs & Recharge page), or tells the customer it's not
// uploaded yet rather than silently doing nothing.
export default function PlanPdfQuickAction({ url }) {
  const handleClick = () => {
    if (!url) { toast('PDF not available yet for your plan', { icon: '📄' }); return; }
    window.open(url, '_blank', 'noreferrer');
  };

  return (
    <button onClick={handleClick} style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, padding: '12px 6px',
      border: '1px solid var(--border)', borderRadius: 12, background: 'none', cursor: 'pointer', width: '100%',
    }}>
      <div style={{
        width: 34, height: 34, borderRadius: 10, background: '#0891b214', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
      }}>
        <FileText size={16} color="#0891b2" />
      </div>
      <span style={{ fontSize: '.72rem', fontWeight: 600, color: 'var(--text)', textAlign: 'center' }}>Plan PDF</span>
    </button>
  );
}
